import { loadSources } from "../util/entropy_source";
import getFonts from "./fonts";
import getCanvasFingerprint from "./canvas";
import getLanguages from "./languages";
import getColorDepth from "./color_depth";
import getDeviceMemory from "./device_memory";
import getScreenResolution from "./screen_resolution";
import getTimezone from "./timezone";
import getTouchSupport from "./touch_support";
import getColorGamut from "./color_gamut";
import getPlatform from "./platform";
import { getWebGlBasics, getWebGlExtensions } from "./webgl";

/**
 * The list of entropy sources used to make visitor identifiers.
 *
 * This value isn't restricted by Semantic Versioning, i.e. it may be changed without bumping minor or major version of
 * this package.
 *
 * Note: Rollup and Webpack are smart enough to remove unused properties of this object during tree-shaking, so there is
 * no need to export the sources individually.
 */
export var sources = {
  // READ FIRST:
  // See https://github.com/fingerprintjs/fingerprintjs/blob/master/contributing.md#how-to-make-an-entropy-source
  // to learn how entropy source works and how to make your own.

  // The sources run in this exact order.
  // The asynchronous sources are at the start to run in parallel with other sources.
  fonts: getFonts,
  // domBlockers: getDomBlockers,
  // fontPreferences: getFontPreferences,
  // audio: getAudioFingerprint,
  // screenFrame: getScreenFrame,

  canvas: getCanvasFingerprint,
  // osCpu: getOsCpu,
  languages: getLanguages,
  colorDepth: getColorDepth,
  deviceMemory: getDeviceMemory,
  screenResolution: getScreenResolution,
  // hardwareConcurrency: getHardwareConcurrency,
  timezone: getTimezone,
  // sessionStorage: getSessionStorage,
  // localStorage: getLocalStorage,
  // indexedDB: getIndexedDB,
  // openDatabase: getOpenDatabase,
  // cpuClass: getCpuClass,
  platform: getPlatform,
  // plugins: getPlugins,
  touchSupport: getTouchSupport,
  // vendor: getVendor,
  // vendorFlavors: getVendorFlavors,
  // cookiesEnabled: areCookiesEnabled,
  colorGamut: getColorGamut,
  // invertedColors: areColorsInverted,
  // forcedColors: areColorsForced,
  // monochrome: getMonochromeDepth,
  // contrast: getContrastPreference,
  // reducedMotion: isMotionReduced,
  // reducedTransparency: isTransparencyReduced,
  // hdr: isHDR,
  // math: getMathFingerprint,
  // pdfViewerEnabled: isPdfViewerEnabled,
  // architecture: getArchitecture,
  // applePay: getApplePayState,
  // privateClickMeasurement: getPrivateClickMeasurement,
  // audioBaseLatency: getAudioContextBaseLatency,

  // Some sources can affect other sources (e.g. WebGL can affect canvas), so it's important to run these sources
  // after other sources.
  webGlBasics: getWebGlBasics,
  webGlExtensions: getWebGlExtensions
};
/**
 * Loads the built-in entropy sources.
 * Returns a function that collects the entropy components to make the visitor identifier.
 */
export default function loadBuiltinSources(options) {
  return loadSources(sources, options, []);
}